export enum MUTATION_KEYS {
  ACCEPT_TOS = 'ACCEPT_TOS',
}

export default MUTATION_KEYS
